var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM14.2071 6.70711C14.5976 6.31658 14.5976 5.68342 14.2071 5.29289C13.8166 4.90237 13.1834 4.90237 12.7929 5.29289L7.5 10.5858L5.20711 8.29289C4.81658 7.90237 4.18342 7.90237 3.79289 8.29289C3.40237 8.68342 3.40237 9.31658 3.79289 9.70711L6.79289 12.7071C7.18342 13.0976 7.81658 13.0976 8.20711 12.7071L14.2071 6.70711Z","fill":"#50B428"}));
}

Check.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Check;

Check.default = Check;
